import React from "react";

export const LegalPage = ({ title, overline, lastUpdated, children, testid }) => (
  <div data-testid={testid} className="bg-ess-paper">
    <section className="bg-ess-emerald text-white">
      <div className="ess-container py-20 md:py-24">
        <p className="ess-overline text-ess-gold">{overline}</p>
        <h1 className="font-display text-5xl md:text-6xl mt-4 leading-tight">{title}</h1>
        {lastUpdated && (
          <p className="mt-4 text-white/65 text-sm tracking-wide">Last updated: {lastUpdated}</p>
        )}
      </div>
    </section>
    <section className="ess-section">
      <div className="ess-container max-w-3xl ess-legal">
        {children}
      </div>
    </section>
  </div>
);

export default LegalPage;
